import React, { createContext, useContext, useState } from 'react';
import dataJson from '../../data/data.json';

const DataContext = createContext();

export function useData() {
  return useContext(DataContext)
}


export default function DataProvider({ children, ...props }) {

  // Destructure data 
  const { navigation, testimonials, faqs, faqs_ccc, faqs_cnc, faqs_aipp, tabs, posts, pricing, Homepages, InnerPage, landingPage } = dataJson;

  const [data, setData] = useState({
    "tabs": tabs,
    "faqs": faqs,
    "faqs_ccc": faqs_ccc,
    "faqs_cnc": faqs_cnc,
    "faqs_aipp": faqs_aipp,
    "posts": posts,
    "pricing": pricing,
    "homepage": Homepages,
    "innerpage": InnerPage,
    "navigation": navigation,
    "testimonials": testimonials,
    "landingpage": landingPage,
  });

  return (
    <DataContext.Provider value={data}>
      {children}
    </DataContext.Provider>
  )
}
